import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ChessZooApp from './ChessZooApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChessZooApp />
  </React.StrictMode>
); 